import {signUp} from 'actions/userActions';
import TextInput from 'components/common/TextInput';
import uiHelper from 'helpers/uiHelper';
import validationHelper from 'helpers/validationHelper';
import md5 from 'md5';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import AuthBackgroundImage from './components/AuthBackgroundImage';
import AuthBodyContainer from './components/AuthBodyContainer';
import AuthContainer from './components/AuthContainer';
import AuthLink from './components/AuthLink';
import AuthTitle from './components/AuthTitle';
import SubmitButton from './components/SubmitButton';

function SignUpPage() {
  const dispatch = useDispatch();
  let history = useHistory();

  const [user, setUser] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    passwordConfirm: '',
    honeypot: ''
  });

  const [errors, setErrors] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    passwordConfirm: ''
  });

  function onChange(field: string, value) {
    setUser({...user, [field]: value});
  }

  function signUpFormIsValid() {
    let newErrors = {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      passwordConfirm: ''
    };

    if (!user.firstName) {
      newErrors.firstName = 'First Name field is required.';
    }

    if (!user.lastName) {
      newErrors.lastName = 'Last Name field is required.';
    }

    if (!user.email) {
      newErrors.email = 'Email field is required.';
    } else if (!validationHelper.isValidEmail(user.email)) {
      newErrors.email = 'Email is not valid.';
    }

    if (!user.password) {
      newErrors.password = 'Password field is required.';
    }

    if (!user.passwordConfirm) {
      newErrors.passwordConfirm = 'Please confirm the password.';
    }

    if (user.password && user.passwordConfirm && user.password !== user.passwordConfirm) {
      newErrors.passwordConfirm = 'Passwords do not match.';
    }

    setErrors(newErrors);

    return validationHelper.isEmptyErrorObject(newErrors);
  }

  async function onSignUp(e) {
    if (e) e.preventDefault();

    if (!isActiveButton()) return;

    if (!signUpFormIsValid()) return;

    user.honeypot = md5(user.email);

    let response: any = await dispatch(signUp(user));

    if (response && response.success) {
      uiHelper.showMessage('User account was successfully created.');

      history.push('/login');
    }
  }

  function isActiveButton() {
    return user.firstName && user.lastName && user.email && user.password && user.passwordConfirm ? true : false;
  }

  function render() {
    let isActive = isActiveButton();

    return (
      <AuthContainer>
        <AuthBackgroundImage />

        <AuthBodyContainer isSignUp={true}>
          <AuthTitle>Sign Up</AuthTitle>

          <form onSubmit={onSignUp}>
            <TextInput
              name="firstName"
              value={user.firstName}
              onChange={onChange}
              placeholder="First Name"
              error={errors.firstName}
            />

            <TextInput
              name="lastName"
              value={user.lastName}
              onChange={onChange}
              placeholder="Last Name"
              error={errors.lastName}
            />

            <TextInput
              name="email"
              type="email"
              value={user.email}
              onChange={onChange}
              placeholder="Email"
              error={errors.email}
            />

            <TextInput
              name="password"
              type="password"
              value={user.password}
              onChange={onChange}
              placeholder="Password"
              error={errors.password}
            />

            <TextInput
              name="passwordConfirm"
              type="password"
              value={user.passwordConfirm}
              onChange={onChange}
              placeholder="Confirm Password"
              error={errors.passwordConfirm}
            />

            <SubmitButton isActive={isActive} title="Sign Up" extraMargin={4} onSubmit={onSignUp} />
          </form>

          <AuthLink url="/login" title="Already have an account?" linkText="Login" />
        </AuthBodyContainer>
      </AuthContainer>
    );
  }

  return render();
}

export default SignUpPage;
